var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgDeco5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M4.76006 40.41C3.1164 38.6786 2.14637 36.4163 2.02532 34.0321C1.90428 31.6478 2.64017 29.299 4.10003 27.41C11.4676 17.966 21.3033 10.7433 32.5196 6.54037C43.736 2.33745 55.8961 1.31803 67.6556 3.5948C79.4152 5.87158 90.3161 11.3559 99.1533 19.4414C107.99 27.5269 114.42 37.8986 117.73 49.41C118.461 51.9601 118.148 54.6959 116.862 57.0158C115.575 59.3356 113.42 61.0493 110.87 61.78C108.32 62.5107 105.584 62.1984 103.264 60.9119C100.944 59.6254 99.2307 57.4701 98.5001 54.92C96.2158 46.9558 91.7739 39.7783 85.6653 34.1808C79.5567 28.5834 72.0193 24.7841 63.8863 23.2028C55.7533 21.6215 47.3414 22.3199 39.5805 25.2207C31.8196 28.1215 25.0119 33.1118 19.91 39.64C18.2848 41.7263 15.8993 43.0839 13.2755 43.4156C10.6517 43.7473 8.00338 43.0262 5.91003 41.41C5.50333 41.1045 5.11905 40.7704 4.76006 40.41V40.41Z",
    stroke: "#31A8FF",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDeco5);
export default __webpack_public_path__ + "static/media/bg_deco_5.f268847b216793e45a1512be5344b94b.svg";
export { ForwardRef as ReactComponent };